const ROOT_URL =
  process.env.NODE_ENV === "production" ? process.env.REACT_APP_API_HOST : "";

const BASE_ENDPOINT = `${ROOT_URL}/api/areas`;

const config = {
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

export const getAreas = async () => {
  const response = await fetch(BASE_ENDPOINT, config);
  const data = await response.json();
  return data;
};

export const createAgentArea = async payload => {
  const response = await fetch(`${BASE_ENDPOINT}/agents`, {
    ...config,
    method: "POST",
    body: JSON.stringify(payload),
  });
  const data = await response.json();
  return data;
};
